import { Fragment } from "react";

import { parseMarkdown, type MdBlock, type TextSpan } from "../model/markdown";

// 渲染纯 React 元素,零 dangerouslySetInnerHTML → 结构上无 XSS 面。
// text span 渲染成裸字符串(Fragment 透传),保证纯文本段落是 <p> 的单一文本节点。
function Spans({ spans }: { spans: TextSpan[] }) {
  return (
    <>
      {spans.map((s, i) => {
        if (s.kind === "bold") return <strong key={i}>{s.value}</strong>;
        if (s.kind === "code")
          return (
            <code key={i} className="rounded bg-muted px-1 py-0.5 text-[0.85em]">
              {s.value}
            </code>
          );
        return <Fragment key={i}>{s.value}</Fragment>;
      })}
    </>
  );
}

function Block({ block }: { block: MdBlock }) {
  switch (block.type) {
    case "heading":
      return (
        <div className={`font-semibold ${block.level <= 1 ? "text-base" : "text-sm"}`}>
          <Spans spans={block.spans} />
        </div>
      );
    case "table":
      return (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-xs">
            <thead>
              <tr>
                {block.headers.map((cell, c) => (
                  <th key={c} className="border border-border px-2 py-1 text-left font-medium">
                    <Spans spans={cell} />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {block.rows.map((row, r) => (
                <tr key={r}>
                  {row.map((cell, c) => (
                    <td key={c} className="border border-border px-2 py-1">
                      <Spans spans={cell} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    case "list": {
      const items = block.items.map((it, k) => (
        <li key={k}>
          <Spans spans={it} />
        </li>
      ));
      return block.ordered ? (
        <ol className="ml-5 list-decimal space-y-0.5">{items}</ol>
      ) : (
        <ul className="ml-5 list-disc space-y-0.5">{items}</ul>
      );
    }
    case "hr":
      return <hr className="my-2 border-border" />;
    case "paragraph":
      return (
        <p className="whitespace-pre-wrap">
          {block.lines.map((spans, l) => (
            <Fragment key={l}>
              {l > 0 && <br />}
              <Spans spans={spans} />
            </Fragment>
          ))}
        </p>
      );
  }
}

export function MarkdownText({ text }: { text: string }) {
  const blocks = parseMarkdown(text);
  return (
    <div className="space-y-2 text-sm">
      {blocks.map((b, i) => (
        <Block key={i} block={b} />
      ))}
    </div>
  );
}
